// extracted by mini-css-extract-plugin
export default {"AvatarTag":"AvatarTag_AvatarTag__UyljT","Avatar":"AvatarTag_Avatar__JWdd8","Name":"AvatarTag_Name__WT77T"};